// ModalToastContext.jsx
import { createContext, useContext, useState } from "react";
import ModalToast from "./ModalToast";

const ModalToastContext = createContext();

export const ModalToastProvider = ({ children }) => {
  const [modal, setModal] = useState(null);

  const show = (message, type = "error") => {
    setModal({ message, type });
  };

  const hide = () => setModal(null);

  return (
    <ModalToastContext.Provider value={{ show, hide }}>
      {children}
      {modal && (
        <ModalToast
          message={modal.message}
          type={modal.type}
          onClose={hide}
        />
      )}
    </ModalToastContext.Provider>
  );
};

export const useModalToast = () => useContext(ModalToastContext);
